module.exports = __webpack_public_path__ + "img/futuro_brillante.76b6a717.jpg";